import React from 'react';

const NoMatch = () => {
    return (
        <div>
            <p className='display-3 text-center text-danger'>   
              Page Not Found
          </p>
        </div>
    );
};

export default NoMatch;